import { FlatConsolidatedData } from './Types';

const calculateNetPay = (month: FlatConsolidatedData): number => (
  (month['Amount per Pay Period'] as number || 0)
  + (month['Overtime per Pay Period'] || 0)
  - (month['Domestic support obligations'] || 0)
  - (month.Insurance || 0)
  - (month['Mandatory contributions for retirement plans'] || 0)
  - (month['Other deductions'] || 0)
  - (month['Required repayments of retirement fund loans'] || 0)
  - (month['Tax, Medicare, and Social Security deductions'] || 0)
  - (month['Union dues'] || 0)
  - (month['Voluntary contributions for retirement plans'] || 0)
);

export default calculateNetPay;